import { isPeselValid } from '../validation';

/**
 *
 * @return formatted date in predefined format
 * @return null if error
 */
export function getDateFromPesel(pesel: string): string | null {
    if (!isPeselValid(pesel)) {
        return null;
    }

    const mm = Number(pesel.substring(2, 4));
    let period: number;
    let realMonth: number;

    // see wiki for PESEL
    if (mm <= 12) {
        period = 1900;
        realMonth = mm;
    } else if (mm <= 32) {
        period = 2000;
        realMonth = mm - 20;
    } else if (mm <= 52) {
        period = 2100;
        realMonth = mm - 40;
    } else if (mm <= 72) {
        period = 2200;
        realMonth = mm - 60;
    } else if (mm <= 92) {
        period = 1800;
        realMonth = mm - 80;
    } else {
        throw new Error(`Can not extract date from Pesel (${pesel})`);
    }

    const day = pesel.substring(4, 6).padStart(2, '0');
    const month = realMonth.toString().padStart(2, '0');

    return `${day}.${month}.${period + Number(pesel.substring(0, 2))}`;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/terminal/poland/core/utils/index.ts